import { useMutation } from '@tanstack/react-query';

import createTicket from './useCreateTicket.request';
import { CreateTicketPayload } from './useCreateTicket.interface';

export default function useCreateTicket() {
    return useMutation({
        mutationFn: (payload: CreateTicketPayload) => createTicket(payload),
    });
}
